/* eslint-disable sort-keys */
export const urls: Record<
  'nl',
  Record<string, '/l/nl/nl' | `/l/nl/nl/${string}`>
> = {
  nl: {
    // Home
    '': '/l/nl/nl/home',

    // Alumni
    alumni: '/l/nl/nl/alumni',

    // B2B
    bedrijven: '/l/nl/nl/b2b',
    'bedrijven/contact': '/l/nl/nl/b2b/apply',

    // Blog
    blog: '/l/nl/nl/blog',

    // Campus
    amsterdam: '/l/nl/nl/campus/ams',
    remote: '/l/nl/nl/campus/rmt',

    // Career
    'carriere-coaching': '/l/nl/nl/career',

    // Courses
    'web-development': '/l/nl/nl/course/wd',
    'data-analytics': '/l/nl/nl/course/da',
    'ux-ui-design': '/l/nl/nl/course/ux',
    cybersecurity: '/l/nl/nl/course/cy',

    // FAQ
    faq: '/l/nl/nl/faq',

    // Financing Options
    financiering: '/l/nl/nl/financing',

    // Forms
    aanmelden: '/l/nl/nl/apply',
    aanmelden2: '/l/nl/nl/full-apply',
    contact: '/l/nl/nl/contact',
    'financiering-formulier': '/l/nl/nl/financing-form',
    bedankt: '/l/nl/nl/thank-you',

    // Syllabus Forms
    'ai-consulting-integratie/curriculum': '/l/nl/nl/syllabus/ac',
    'kunstmatige-intelligentie/curriculum': '/l/nl/nl/syllabus/ai',
    'cloud-engineer/curriculum': '/l/nl/nl/syllabus/ce',
    'cybersecurity/curriculum': '/l/nl/nl/syllabus/cy',
    'data-analytics/curriculum': '/l/nl/nl/syllabus/da',
    'data-engineering/curriculum': '/l/nl/nl/syllabus/de',
    'devops-cloud-computing/curriculum': '/l/nl/nl/syllabus/dv',
    'digital-marketing/curriculum': '/l/nl/nl/syllabus/mk',
    'data-science-machine-learning/curriculum': '/l/nl/nl/syllabus/ml',
    'product-manager-ai/curriculum': '/l/nl/nl/syllabus/pm',
    'ux-ui-design/curriculum': '/l/nl/nl/syllabus/ux',
    'web-development/curriculum': '/l/nl/nl/syllabus/wd',

    // PDP
    'ai-consulting-integratie/remote': '/l/nl/nl/pdp/ac/rmt',
    'kunstmatige-intelligentie/remote': '/l/nl/nl/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/nl/nl/pdp/ce/rmt',
    'data-engineering/remote': '/l/nl/nl/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/nl/nl/pdp/dv/rmt',
    'digital-marketing/remote': '/l/nl/nl/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/nl/nl/pdp/ml/rmt',
    'product-manager-ai/remote': '/l/nl/nl/pdp/pm/rmt',
  },
};
/* eslint-enable sort-keys */
